import { TrackingEventName } from '@/models/analytics/eventTypes';
import {
  trackReferralCompletedSpec,
  trackReferralCreatedSpec,
  trackReferralSharedSpec,
  trackReferralViewedSpec,
  type ReferralCompleted,
  type ReferralCreated,
  type ReferralShared,
  type ReferralViewed,
} from '@snowtype/snowplow';
import type { SnowplowEventMap } from '../trackSnowplowEvent';

export const referralEvents: SnowplowEventMap = {
  [TrackingEventName.ReferralCreated]: (props) =>
    trackReferralCreatedSpec(props as ReferralCreated),
  [TrackingEventName.ReferralCompleted]: (props) =>
    trackReferralCompletedSpec(props as ReferralCompleted),
  [TrackingEventName.ReferralShared]: (props) =>
    trackReferralSharedSpec(props as ReferralShared),
  [TrackingEventName.ReferralViewed]: (props) =>
    trackReferralViewedSpec(props as ReferralViewed),
};
